export const ALLOW_TRACKING = 'allow-tracking';
